import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold tracking-wide transition-colors',
  {
    variants: {
      variant: {
        default:  'border border-border bg-tint/10 text-content-secondary',
        primary:  'border border-primary-500/40 bg-primary-500/15 text-primary-300',
        success:  'border border-success-500/35 bg-success-500/15 text-success-500',
        warning:  'border border-warning-500/35 bg-warning-500/15 text-warning-500',
        danger:   'border border-danger-500/35 bg-danger-500/15 text-danger-500',
        info:     'border border-info-500/35 bg-info-500/15 text-info-500',
        outline:  'border border-border-strong bg-transparent text-content-secondary',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
